export enum LoanTransactionStatusId {
	PENDING = 1,
	POSTED = 2,
	SUBMITTED_TO_GL = 3,
	CANCELLED = 10,
	TAKE_BACK_DECLINED = 11,
	FAILED = 12,
	REVERSAL_SUBMITTED_TO_GL = 98,
	REPLAYING = 97,
	REVERSED = 99,
}
